import React from 'react';
import { UserMenuConsumer } from '../context/UserMenuContext';
import styled from '@emotion/styled';
import MenuOpen from './MenuOpen';
import MenuClose from './MenuClose';

const Toggle = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-left: 1px solid #e4e4e4;
  height: 100%;
  width: 11rem;
  background: none;
  color: inherit;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  background: ${p => (p.active ? '#57a8e6' : '#ffffff')};

  :hover {
    transition: background 300ms ease;
    background: #57a8e6;
  }

  :hover svg path {
    fill: #ffffff;
  }

  :hover span {
    color: #ffffff;
  }
`;

const UserSnippet = styled.div`
  display: inline-flex;
  align-items: center;
`;

const UserName = styled.span<{ active: boolean }>`
  font-size: 0.9rem;
  font-weight: 600;
  margin-left: 0.5rem;
  user-select: none;
  padding-bottom: 0.1rem;

  color: ${p => (p.active ? '#ffffff' : '#4694ce')};
  display: ${p => (p.active ? 'none' : 'inline-block')};
`;

interface Props {
  userName: string;
}

const UserToggle = (props: Props) => {
  return (
    <UserMenuConsumer>
      {({ state, toggle }) => (
        <Toggle data-testid="user-toggle-toggle" active={state.active} onClick={toggle}>
          <UserSnippet>
            <MenuOpen />
            <UserName data-testid="user-toggle-username" active={state.active}>
              {props.userName}
            </UserName>
          </UserSnippet>
          <MenuClose />
        </Toggle>
      )}
    </UserMenuConsumer>
  );
};

export { UserToggle, UserToggle as default };
